export default __webpack_public_path__ + "static/media/Group_15123.f55489f3.svg";